<script lang="ts">
    import { useNavigate } from "svelte-navigator";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { user } from "../../../../store/stores";

    const navigate = useNavigate();

    let activeState = "false";
    let networkName = "";
    let fetching: boolean = false;
    let status: boolean | null = null;
    let errorMessage: string = "Die Erstellung ist fehlgeschlagen.";

    const createNewNetwork = async () => {
        if (networkName && networkName !== "") {
            await $user.updateToken().then(async () => {
                ApiClient.getInstance()
                    .networkClient.createNetwork({
                        networkRequest: {
                            name: networkName,
                            active: activeState === "true",
                        },
                    })
                    .then(() => {
                        fetching = false;
                        status = true;
                    })
                    .catch((error) => {
                        fetching = false;
                        status = false;
                        errorMessage = error;
                    });
            });
        }
    };
</script>

w
<div class="container">
    <section class="section">
        <h1 class="title">Netzwerk erstellen</h1>
    </section>
    <section class="section">
        <div class="columns">
            <div class="column is-half is-offset-one-quarter">
                {#if status}
                    <div class="notification is-success">
                        <button
                            class="delete"
                            on:click={() => (status = null)}
                        />
                        <p>
                            Das Netzwerk <b>{networkName}</b> wurde angelegt.
                        </p>
                    </div>
                {:else if status === false}
                    <div
                        class="notification is-danger"
                        on:click={() => (status = null)}
                    >
                        <button class="delete" />
                        <p>{errorMessage}</p>
                    </div>
                {/if}
                <div class="box">
                    <div class="field">
                        <label for="networkName" class="label field-name"
                            >Netzwerkname</label
                        >
                        <div class="control">
                            <input
                                class="input"
                                type="text"
                                placeholder="Netzwerkname"
                                name="networkName"
                                bind:value={networkName}
                            />
                        </div>
                    </div>
                    <div class="field">
                        <div class="control">
                            <label class="radio">
                                <input
                                    type="radio"
                                    name="inactive"
                                    bind:group={activeState}
                                    value={"false"}
                                />
                                Inaktiv
                            </label>
                            <label class="radio">
                                <input
                                    type="radio"
                                    name="active"
                                    bind:group={activeState}
                                    value={"true"}
                                />
                                Aktiv
                            </label>
                        </div>
                    </div>
                    <div
                        class="field is-grouped is-flex is-justify-content-space-between"
                    >
                        <div class="control">
                            <button
                                class="button is-link {fetching
                                    ? 'is-loading'
                                    : ''}"
                                on:click={() => createNewNetwork()}
                                >Erstellen</button
                            >
                        </div>
                        <div class="control">
                            <button
                                class="button is-link is-light"
                                on:click={() => navigate(-1)}>Abbrechen</button
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<style>
    .field-name {
        text-align: left;
    }
</style>
